<template>
    <tr
        :class="{
            'enq-container-green': !enquiry.order && greenContainer,
            'enq-container-red': !enquiry.order && redContainer,
        }"
        v-show="show"
    >
        <td>
            <span>
                <img
                    :src="iconPath + '/flags/' + enquiry.countryCode + '.png'"
                    :alt="enquiry.country.name ?? ''"
                    :title="enquiry.country.name ?? ''"
                />
            </span>

            <span v-if="!enquiry.companyName">
                <span v-if="enquiry.referralMethodID === 11">{{
                    __("Call Back Request")
                }}</span>
                <span v-else>{{ __("New / Blank Enquiry") }}</span>
            </span>
            <span v-else>
                <span>{{ trimmedName }}</span>
            </span>
        </td>

        <td>
            <span v-if="enquiry.order">
                <!-- Search requires EnquiryID (OrderID) but orders require OrderID (EnquiryID) -->
                <abbr :title="enquiry.order.orderID" v-if="search">{{
                    enquiry.id
                }}</abbr>
                <abbr :title="enquiry.id" v-else>{{
                    enquiry.order.orderID
                }}</abbr>
            </span>
            <span v-else>{{ enquiry.id }}</span>
        </td>

        <td>
            <span>{{ formattedDate }}</span>
        </td>
        <td>
            <span>{{ enquiry.valid_enquiry_parts_no_kb.length }}</span>
        </td>

        <td>
            <span>{{ formattedValue }}</span>
        </td>
        <td>
            <span>{{ formattedProfit }}</span>
        </td>
        <td :class="{ 'txt-red': isMarginRed }">
            <span>{{ formattedMargin }}%</span>
        </td>

        <td>
            <span>{{ partName }}</span>
        </td>

        <td data-prevent-click>
            <enq-portion-user-allocating
                class="
                    form-control form-control-sm
                    custom-select custom-select-xs
                "
                :current-category-id="currentCategoryId"
                :enquiry-user="enquiry.user_id"
                :enquiry-id="enquiry.id"
                :can-unallocate="
                    null === enquiry.order || undefined === enquiry.order
                "
                :users="users"
                :on-allocated="onAllocated"
            ></enq-portion-user-allocating>
        </td>

        <td data-prevent-click>
            <div class="d-flex flex-row text-center justify-content-center">
                <div class="enq-marker" v-if="enquiry.company_contact_id > 0">
                    <i
                        class="fas fa-user text-secondary"
                        :alt="__('Existing')"
                        :title="__('Existing')"
                    ></i>
                </div>
                <div class="enq-marker" v-else>
                    <i
                        class="fas fa-user text-info"
                        :alt="__('New')"
                        :title="__('New')"
                    ></i>
                </div>

                <div class="enq-marker" v-if="enquiry.is_blacklisted">
                    <i
                        class="fas fa-flag text-danger"
                        :alt="__('Blacklisted')"
                        :title="__('Blacklisted')"
                    ></i>
                </div>
                <div class="enq-marker" v-else>
                    <i class="fas fa-flag text-secondary"></i>
                </div>

                <div class="enq-marker" v-if="enquiry.urgentMarker">
                    <i
                        class="fas fa-stopwatch text-danger"
                        :alt="__('Urgent')"
                        :title="__('Urgent')"
                    ></i>
                </div>
                <div class="enq-marker" v-else>
                    <i class="fas fa-stopwatch text-secondary"></i>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
const dateFns = require('date-fns');

const { format, parse } = dateFns;

export default {
    name: "EnqRow",
    props: {
        currentCategoryId: {
            required: true,
            type: Number,
        },
        iconPath: {
            required: true,
            type: String,
        },
        enquiry: {
            required: true,
            type: Object,
        },
        users: {
            required: true,
            type: Array,
        },
        search: {
            required: false,
            type: Boolean,
        },
    },
    data() {
        return {
            selectedUser: this.enquiry.user_id,
            show: true,
        };
    },
    computed: {
        redContainer() {
            if (this.search) return false;
            return (
                !this.greenContainer &&
                this.currentCategoryId > 2 &&
                this.currentCategoryId < 6 &&
                this.enquiry.quoteMarker &&
                this.enquiry.quoteReadCount <= 0
            );
        },

        greenContainer() {
            if (this.search) return false;
            return !this.enquiry.userReadMarker;
        },

        trimmedName() {
            var text = this.enquiry.companyName;
            return text.slice(0, 50) + (text.length > 50 ? "..." : "");
        },

        formattedDate() {
            let d = this.enquiry.dateReceived;
            if (this.enquiry.order) {
                d = this.enquiry.dateWon;
            }

            const p =parse(d, "yyyy-MM-dd HH:mm:ss", new Date());

            return p.toLocaleDateString() + ' @ ' + format(p, 'HH:mm');
        },

        formattedValue() {
            return number_format(this.enquiry.calculated_stats.value, 2);
        },

        formattedProfit() {
            return number_format(this.enquiry.calculated_stats.profit, 2);
        },

        formattedMargin() {
            return number_format(this.enquiry.calculated_stats.margin, 2);
        },

        isMarginRed() {
            return (
                this.enquiry.calculated_stats.margin < MARGIN_PERCENTAGE &&
                (this.enquiry.order || this.currentCategoryId > 2)
            );
        },

        partName() {
            if (this.enquiry.first_part === null) {
                return __("N/A");
            }
            return (
                this.enquiry.first_part.part.manufacturer.manufacturerName +
                " " +
                this.enquiry.first_part.part.partNo
            );
        },
    },

    methods: {
        onAllocated(selectedUser) {
            if (
                0 === selectedUser ||
                (!this.enquiry.order &&
                    0 !== selectedUser &&
                    1 === this.currentCategoryId)
            ) {
                if (!this.enquiry.order) {
                    this.show = false;
                }
                $("#refresh-button").show();
            } else if (0 !== selectedUser && 1 !== this.currentCategoryId) {
                this.greenContainer = true;
                $("#refresh-button").show();
            }
        },
    },
};
</script>
